// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1Nj6s","header":"PatientQuestionnaire_header__1tKPT","info":"PatientQuestionnaire_info__2JNSI"};